import React from 'react';
import { NavLink, useParams } from 'react-router-dom';
import styled from 'styled-components';

import { Controls, ControlsButton } from '@/components/Controls';

const Top = styled.div`
  display: flex;
  margin-bottom: 12px;
`;

const SettingsNavigation = () => {
  const { teamId } = useParams();

  return (
    <Top>
      <Controls>
        <NavLink
          to={`/teams/${teamId}/distribution/settings/employees`}
          children={({ isActive }) => (
            <ControlsButton active={isActive} as="span">
              Employees
            </ControlsButton>
          )}
        />
        <NavLink
          to={`/teams/${teamId}/distribution/settings/watermarks`}
          children={({ isActive }) => (
            <ControlsButton active={isActive} as="span">
              Watermarks
            </ControlsButton>
          )}
        />
        <NavLink
          to={`/teams/${teamId}/distribution/settings/groups`}
          children={({ isActive }) => (
            <ControlsButton active={isActive} as="span">
              Channel groups
            </ControlsButton>
          )}
        />
      </Controls>
    </Top>
  );
};

export default SettingsNavigation;
